// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"871":"48ca5eb8","930":"dc462185"}[chunkId] + ".chunk.css";
};